var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCleared = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40",
  ref: ref
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "#2BA18D",
  rx: 20
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M19 19h2v-7a.968.968 0 0 0-.287-.713A.968.968 0 0 0 20 11a.968.968 0 0 0-.712.287A.968.968 0 0 0 19 12v7Zm-6 4h14v-2H13v2Zm-1.45 6H14v-2c0-.283.096-.52.288-.712A.968.968 0 0 1 15 26c.284 0 .521.096.713.288.192.191.287.429.287.712v2h3v-2c0-.283.096-.52.288-.712A.968.968 0 0 1 20 26c.284 0 .521.096.713.288.191.191.287.429.287.712v2h3v-2c0-.283.096-.52.288-.712A.968.968 0 0 1 25 26c.284 0 .521.096.713.288.191.191.287.429.287.712v2h2.45l-1-4h-14.9l-1 4Zm16.9 2h-16.9c-.65 0-1.175-.258-1.575-.775a1.894 1.894 0 0 1-.35-1.725L11 23v-2c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 13 19h4v-7c0-.833.292-1.542.875-2.125A2.893 2.893 0 0 1 20 9c.834 0 1.542.292 2.125.875.584.583.875 1.292.875 2.125v7h4c.55 0 1.021.196 1.413.587.392.392.587.863.587 1.413v2l1.375 5.5c.217.633.121 1.208-.287 1.725-.409.517-.954.775-1.638.775Z"
})));
SvgCleared.viewBox = '0 0 40 40';
const ForwardRef = /*#__PURE__*/forwardRef(SvgCleared);
export default ForwardRef;